/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { memo, useEffect, useMemo, useState } from "react";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import AppText from "../other/AppText";
//import { AppIconButton } from "../buttons/AppIconButton";
//import { ChevronRight } from "lucide-react";
import LocationCard from "./LocationCard";

interface IBranchDirectory {
  branches: any;
  dict: { [key: string]: string };
}

const BranchDirectory = memo(({ branches, dict }: IBranchDirectory) => {
  const [renderBranches, setRenderBranches] = useState<any>();

  useEffect(() => {
    if (branches) {
      const sortedBranches: any = {};

      for (const branch of branches) {
        if (!sortedBranches[branch.country]) {
          sortedBranches[branch.country] = {};
          sortedBranches[branch.country][branch.state] = [];
        }

        if (!sortedBranches[branch.country][branch.state]) {
          sortedBranches[branch.country][branch.state] = [];
        }

        sortedBranches[branch.country][branch.state].push(branch);
      }

      setRenderBranches(sortedBranches);
    }
  }, [branches]);

  return renderBranches ? (
    <div>
      {renderBranches["United States"] && (
        <BranchAccordion
          country="United States"
          branches={renderBranches["United States"]}
          moreDetails={dict.moreDetails}
        />
      )}
      {renderBranches["Canada"] && (
        <BranchAccordion country="Canada" branches={renderBranches["Canada"]} moreDetails={dict.moreDetails} />
      )}
      {renderBranches["Mexico"] && (
        <BranchAccordion country="Mexico" branches={renderBranches["Mexico"]} moreDetails={dict.moreDetails} />
      )}
    </div>
  ) : (
    <div>no data</div>
  );
});

BranchDirectory.displayName = "BranchDirectory";

export default BranchDirectory;

const BranchAccordion = ({
  country,
  branches,
  moreDetails,
}: {
  country: string;
  branches: any;
  moreDetails: string;
}) => {
  const render = useMemo(() => {
    if (!branches) return [];
    return Object.keys(branches).sort();
  }, [branches]);

  return (
    <>
      <AppText type="TITLE_LARGE">{country}</AppText>
      <Accordion type="multiple" className="w-full mb-[56px] mt-2">
        {render.map((state: string) => {
          const current = branches[state];

          return (
            <AccordionItem key={state} value={state}>
              <AccordionTrigger
                className={`outline-royal-blue outline-offset-2 hover:no-underline 
              font-saira text-16 font-[500] leading-[1.75] tracking-[-0.1px]`}
              >
                {state}
              </AccordionTrigger>

              <AccordionContent className="px-8 py-10 bg-white">
                <div className="flex flex-wrap gap-10">
                  {current.map((item: any) => (
                    <LocationCard item={item} key={item.id} moreDetails={moreDetails} />
                    // <div key={item.id} className="flex flex-col min-w-[242px]">
                    //   <AppText type="TITLE_SMALL" className="leading-0 text-ellipsis mb-1">
                    //     {item.name}
                    //   </AppText>
                    //   <AppText type="BODY_SMALL" className="leading-0 text-ellipsis">
                    //     {item.phone}
                    //   </AppText>
                    //   <AppText type="BODY_SMALL" className="leading-0 text-ellipsis">
                    //     {item.address}
                    //   </AppText>
                    //   <AppText type="BODY_SMALL" className="leading-0 text-ellipsis mb-4">
                    //     {`${item.city}, ${item.state} ${item.zipCode}`}
                    //   </AppText>

                    //   <AppIconButton
                    //     intent="ghost"
                    //     label={moreDetails}
                    //     link={`/locations/${item.stateSlug}/${item.slug}`}
                    //     icon={<ChevronRight size={20} aria-label="chevron right icon" />}
                    //     iconOnRightSide
                    //     className="after:left-0 after:right-0 pl-0"
                    //   />
                    // </div>
                  ))}
                </div>
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </>
  );
};
